import { Component, Inject, ViewEncapsulation, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogData, FnCnfModalType } from '../fn-dialog.model';
import { FnI18nService } from '../../../i18n/fn-i18.service';


/**
 * Component use as Confirmation Modal open via FnModalService.
 * And open as Of Differnt Type like sucess, error, warning, Information and danger.
 * To use this component import FnDialogModule in Module.
 */
@Component({
	templateUrl: 'fn-confirm-modal.component.html',
	encapsulation: ViewEncapsulation.None,
})
export class FnConfirmModalComponent implements OnInit {
	/**
	 * Creates an instance of fn confirm modal component.
	 *
	 * @param dialogRef  Reference to a Confirmation Modal opened via the FnModalService.
	 *
	 * @param dialogData Injection token that can be used to access the data that was passed in to a dialog.
	 *
	 */
	constructor(
		public dialogRef: MatDialogRef<FnConfirmModalComponent>,
		@Inject(MAT_DIALOG_DATA) public dialogData: DialogData,
    private i18Svcs: FnI18nService,
	) {}

	/**
	 * Member Variable of Type FnCnfModalType.
	 * used to show the type of Confirmation model.
	 */
	type: FnCnfModalType;

	/**
	 * Implementing ngOnInit event Handler of Component
	 * sets the type member Variable.
	 */
	ngOnInit(): void {
		if (this.dialogData.type === undefined) {
			this.type = 'sucess';
		} else {
			this.type = this.dialogData.type;
		}
		if(this.dialogData.isConformationMdl){
			this.dialogData.titleClass = this.dialogData.titleClass ||'fn-global-warning-fill font-24 mr-5';
			this.dialogData.title = this.dialogData.title || this.i18Svcs.translate('CONFIRMATION');
		}
	}

	/**
	 * Closes fn confirm modal component on click Ok And Close Button
	 *
	 * @param [isOkey] true when click on OK Button And False when click on Close Button.
	 */
	close(isClose: boolean) {
		this.dialogRef.close(isClose);
	}
}
